<template>
  <path
    d="M27.5 20a1.25 1.25 0 0 1-1.25 1.25H3.75A1.25 1.25 0 0 1 2.5 20v-2.5h25V20zm-15 7.5h5v-3.75h-5v3.75zM2.5 3.75A1.25 1.25 0 0 1 3.75 2.5h22.5a1.25 1.25 0 0 1 1.25 1.25V15h-25V3.75zM26.25 0H3.75A3.75 3.75 0 0 0 0 3.75V20a3.75 3.75 0 0 0 3.75 3.75H10v3.75H7.5a1.25 1.25 0 0 0 0 2.5h15a1.25 1.25 0 0 0 0-2.5H20v-3.75h6.25A3.75 3.75 0 0 0 30 20V3.75A3.75 3.75 0 0 0 26.25 0z"
    fill-rule="evenodd"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ComputerIcon",
});
</script>
